module.exports = __webpack_public_path__ + "img/gw-logo-tall.dc38aa94.png";